var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"st-view"},[_c('div',{staticClass:"loading-view"},[_c('Spinner',{staticClass:"center gray"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }